<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Globo terráqueo: círculo + meridiano vertical + dos paralelos -->
    <circle cx="12" cy="12" r="9" stroke-linecap="round" stroke-linejoin="round" />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3 12h18"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M12 3a13.5 13.5 0 0 1 0 18M12 3a13.5 13.5 0 0 0 0 18"
    />
  </svg>
</template>
<script>
export default { name: 'IconWeb' }
</script>
